import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { setWhoWitnessedOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'

export function* getWhoWitnessedOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getWhoWitnessedOptions])
    const { entity } = response
    yield put(setWhoWitnessedOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getWhoWitnessedOptions() error: ${e}`))
  }
}

export function* getWhoWitnessedOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getWhoWitnessedOptions)
}
